// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `ion-item {
  border-top: 1px solid #ffd278;
  --ion-safe-area-left: 0;
  --inner-padding-end: 0;
}`, "",{"version":3,"sources":["webpack://./src/app/layouts/main/pages/alarm-view/alarm-view.component.scss"],"names":[],"mappings":"AAAA;EACE,6BAAA;EACA,uBAAA;EACA,sBAAA;AACF","sourcesContent":["ion-item {\r\n  border-top: 1px solid #ffd278;\r\n  --ion-safe-area-left: 0;\r\n  --inner-padding-end: 0;\r\n}\r\n"],"sourceRoot":""}]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___.toString();
